import { Google as GoogleIcon } from "@mui/icons-material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Box, Button, Divider, Typography } from "@mui/material";
import { getSignInErrorDetails } from "../auth/signInErrorDetails";
import { useLoginFlow } from "../auth/useLoginFlow";
import { logLoginEvent } from "../misc/firebase";
import EmailLinkLogin from "./EmailLinkLogin";
import EmailPasswordLogin from "./EmailPasswordLogin";
import ReturnToPasswordLoginButton from "./ReturnToPasswordLoginButton";
import SignInSignUpContainer from "./SignInSignUpContainer";

const LoginChooser = () => {
  const { mode, setMode, isSigningIn, enqueueLoginError, handleGoogleLogin, handleTravel360Login, handleEmailLogin } =
    useLoginFlow("EMAIL_PASSOWORD");

  if (mode === "EMAIL_LINK" || mode === "EMAIL_LINK_CONFIRM") {
    return (
      <SignInSignUpContainer minWidth="550px">
        <EmailLinkLogin
          isSignInWithEmailLink={mode === "EMAIL_LINK_CONFIRM"}
          onStartLogin={handleEmailLogin}
          onLoginSuccess={() => logLoginEvent("email_link")}
          onLoginFailed={(error) => enqueueLoginError(getSignInErrorDetails(error))}
        />
        <ReturnToPasswordLoginButton onClick={() => setMode("EMAIL_PASSOWORD")} />
      </SignInSignUpContainer>
    );
  }

  return (
    <SignInSignUpContainer>
      <EmailPasswordLogin
        onLoginSuccess={() => logLoginEvent("email_and_password")}
        onLoginFailed={(error) => enqueueLoginError(getSignInErrorDetails(error))}
      />
      <>
        <Divider sx={{ my: 3, "&::before, &::after": { borderColor: "rgba(0,0,0,0.1)" } }}>
          <Typography variant="body2" color="textSecondary">
            lub zaloguj za pomocą
          </Typography>
        </Divider>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 4 }}>
          <Button
            onClick={handleTravel360Login}
            disabled={isSigningIn}
            fullWidth
            variant="outlined"
            startIcon={<TravelExploreIcon />}
            sx={{
              py: 1.2,
              borderRadius: 2,
              color: "text.primary",
              borderColor: "rgba(0,0,0,0.2)",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            id.travel360
          </Button>
          <Button
            onClick={handleGoogleLogin}
            disabled={isSigningIn}
            fullWidth
            variant="outlined"
            startIcon={<GoogleIcon sx={{ color: "#DB4437" }} />}
            sx={{
              py: 1.2,
              borderRadius: 2,
              color: "text.primary",
              borderColor: "rgba(0,0,0,0.2)",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Google
          </Button>
        </Box>
      </>

      <Box sx={{ textAlign: "center" }}>
        <Button
          variant="text"
          color="primary"
          onClick={() => setMode("EMAIL_LINK")}
          sx={{ fontWeight: 600, textTransform: "none", mb: 1 }}
        >
          Zaloguj bez hasła (wyślij link)
        </Button>
      </Box>
    </SignInSignUpContainer>
  );
};

export default LoginChooser;
